"use strict";

var triggerAnalyticsSync = function triggerAnalyticsSync(_event, _payload) {
  var target = window.document;
  var eventName = _event;
  var params = {
    detail: _payload || {},
    bubbles: true,
    cancelable: true
  };

  try {
    var event = new CustomEvent(eventName, params);
    target.dispatchEvent(event);
  } catch (e) {
    var fallbackEvent = document.createEvent('Event');
    fallbackEvent.initEvent(eventName, params.bubbles, params.cancelable, params.detail);

    if (target.addEventListener) {
      target.dispatchEvent(fallbackEvent);
    } else {
      target.attachEvent(eventName);
    }
  }
};

var triggerAnalytics = function triggerAnalytics() {
  return new Promise(function (resolve, reject) {
    if (window._satellite) {
      resolve(triggerAnalyticsSync);
    } else {
      reject(new Error('Adobe Launch not loaded'));
    }
  });
};

module.exports = {
  triggerAnalytics: triggerAnalytics,
  triggerAnalyticsSync: triggerAnalyticsSync
};